const mobileMenu  = document.querySelector('.dtcMobileMenu');
const menu = document.querySelector('.dtcMobileMenu__menu');
const menuBackButton  = document.querySelector('.dtcMobileMenuHeader');
const submenus  = document.querySelectorAll('.dtcMobileMenu__submenu');
const menuToggleButton  = document.querySelector('#mobileMenuToggler');
const body  = document.querySelector('body');
const html  = document.querySelector('html');
const header  = document.querySelector('header');
const announcementBar = document.querySelector('#Bar');
const footer = document.querySelector('.dtcMobileMenu__footer');
const bestSellers = document.querySelector('.dtc-mobile-menu__best-sellers');

document.addEventListener('click', (e) => {
  const target = e.target;
  if(target?.closest('#mobileMenuToggler')) toggleMobileMenu();
});

// Focus trap handler — attached while the menu is open
function trapFocus(e) {
  if (e.key === 'Escape') {
    e.preventDefault();
    toggleMobileMenu();
    return;
  }

  if (e.key !== 'Tab') return;

  const focusable = Array.from(mobileMenu.querySelectorAll(
    'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
  )).filter(el => el.offsetParent !== null);

  if (!focusable.length) return;

  const first = focusable[0];
  const last  = focusable[focusable.length - 1];

  if (e.shiftKey) {
    if (document.activeElement === first) {
      e.preventDefault();
      last.focus();
    }
  } else {
    if (document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }
}

function toggleMobileMenu() {
  window.mobileMenuOpened = !!!window.mobileMenuOpened;
  let isOpen = mobileMenu.classList.contains('slide-in');
  toggleActiveClass(mobileMenu);
  const toggleBtn = document.querySelector('#mobileMenuToggler button');
  if (toggleBtn) toggleBtn.setAttribute('aria-expanded', String(!isOpen));

  const classListAction = isOpen ? 'remove' : 'add';
  const announcementDisplay = isOpen ? 'flex' : 'none';

  html.classList[classListAction]("modal-overlay-active");
  html.classList[classListAction]("overflow-hidden-tablet");
  html.classList[classListAction]("menu_open_body");

  const announcementBar = document.querySelector('html .announcement-top');
  mobileMenu.classList.toggle('slide-in', !isOpen);
  mobileMenu.classList.toggle('slide-out', isOpen);
  announcementBar.style.display = announcementDisplay;

  if (!isOpen) {
    // Menu is opening
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.addEventListener('keydown', trapFocus);

    let myEvent = new CustomEvent('open:menu', {
      detail: { message: 'mobile menu opened' }
    });
    document.dispatchEvent(myEvent);
    document.dispatchEvent(new CustomEvent('dtc:mobileMenu::opened'));

    // Move focus to the first interactive item after the slide animation
    setTimeout(() => {
      const firstItem = mobileMenu.querySelector(
        '.dtcMobileMenu__MenuItems > .dtcMobileMenu__item > a, ' +
        '.dtcMobileMenu__MenuItems > .dtcMobileMenu__item > button'
      );
      if (firstItem) firstItem.focus();
    }, 220);
  } else {
    // Menu is closing
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', trapFocus);

    // Return focus to the toggle button
    if (toggleBtn) setTimeout(() => toggleBtn.focus(), 50);
  }
}

function openSubmenu(el) {
  const screen_width = window.screen.width;
  const submenu = el.nextElementSibling;
  submenu.style.right = screen_width + 'px';
  toggleActiveClass(submenu);
  footer.classList.add('hidden');
  bestSellers && bestSellers.classList.add('hidden');

  // Reflect expanded state
  const trigger = el.querySelector('[aria-expanded]');
  if (trigger) trigger.setAttribute('aria-expanded', 'true');

  // Move focus to the first item inside the submenu
  setTimeout(() => {
    const firstSubItem = submenu.querySelector('ul a, ul button');
    if (firstSubItem) firstSubItem.focus();
  }, 50);
}

function closeSubmenu() {
  submenus.forEach((submenu) => {
    submenu.classList.remove('active');
    footer.classList.remove('hidden');
    bestSellers && bestSellers.classList.remove('hidden');
  });

  // Reset all expanded states
  mobileMenu.querySelectorAll('[aria-expanded="true"]').forEach(el => {
    el.setAttribute('aria-expanded', 'false');
  });

  // Return focus to the trigger button that opened this submenu
  const openTrigger = mobileMenu.querySelector(
    '.dtcMobileMenu__MenuItems > .dtcMobileMenu__item > button'
  );
  if (openTrigger) openTrigger.focus();
}

function toggleActiveClass(el){
  el.classList.toggle("active");
}
